// extracted by mini-css-extract-plugin
export default {"table":"Table_table__9c28b","empty":"Table_empty__ABXfN","pagination":"Table_pagination__aE1wA"};